// src/components/FullScreenMenu.tsx
import React from "react";
import { Link } from "react-router-dom";
import Logo from "../../../assets/logo.png";
import "./FullScreenMenu.css";
import { InstagramIcon, LinkedInIcon, WhatsAppIcon } from "../../utils/constants";
import { getRoutePaths, useLang } from "../../utils/i18n";

export const FullScreenMenu = ({ isOpen, onClose }) => {
  // ← FIXED: Always render so transition can start from closed state
  const lang = useLang();
  const paths = getRoutePaths(lang);
  const copy = {
    en: {
      about: "About",
      beliefs: "What We Believe",
      services: "Services",
      school: "Monetique School",
      contact: "Contact",
      addressLabel: "Brazil",
      explore: "Explore",
      privacy: "Privacy Policy",
      disclaimer: "Legal Disclaimer",
      principles: "Our Principles",
    },
    pt: {
      about: "Sobre",
      beliefs: "O que acreditamos",
      services: "Serviços",
      school: "Monetique School",
      contact: "Contato",
      addressLabel: "Brasil",
      explore: "Explorar",
      privacy: "Política de Privacidade",
      disclaimer: "Aviso Legal",
      principles: "Nossos Princípios",
    },
  };

  const closeMenu = () => {
    onClose();
  };
  return (
    <div id="site-menu" className={`fullscreen-overlay ${isOpen ? "open" : ""}`} onClick={closeMenu} aria-hidden={!isOpen}>
      <div className="fullscreen-content" onClick={(e) => e.stopPropagation()}>
        <div className="fullscreen-main">
          <nav className="fullscreen-nav">
            <Link to={paths.about} className="nav-link" onClick={closeMenu}>
              {copy[lang].about}
            </Link>
            <Link to={paths.services} className="nav-link" onClick={closeMenu}>
              {copy[lang].services}
            </Link>
            <Link to={paths.school} className="nav-link" onClick={closeMenu}>
              {copy[lang].school}
            </Link>
            <Link to={paths.contact} className="nav-link" onClick={closeMenu}>
              {copy[lang].contact}
            </Link>
          </nav>

          <aside className="fullscreen-info">
            <p className="address">
              Monetique Estratégia e Gestão Financeira Ltda.
              <br />
              Avenida Brigadeiro Faria Lima, 1811
              <br />
              Sala 1119
              <br />
              São Paulo, SP, {copy[lang].addressLabel}
              <br />
              <br />
              <a href="tel:+5511944794757">+55 11 94479-4757</a>
              <br />
              <a href="mailto:info@monetiquepro.com" className="email-link">info@monetiquepro.com</a>
              <br />
            </p>
            <div className="social-icons">
              <div>
                <LinkedInIcon />
              </div>
              <div>
                <InstagramIcon />
              </div>
              <div>
                <WhatsAppIcon />
              </div>
            </div>
          </aside>
        </div>
        <nav
          className="fullscreen-utility"
          aria-label={copy[lang].explore}
        >
          <div className="fullscreen-utility-links">
            <Link to={paths.privacy} onClick={closeMenu}>{copy[lang].privacy}</Link>
            <Link to={paths.disclaimer} onClick={closeMenu}>{copy[lang].disclaimer}</Link>
            <Link to={paths.contact} onClick={closeMenu}>{copy[lang].contact}</Link>
            <Link to={paths.beliefs} onClick={closeMenu}>{copy[lang].principles}</Link>
          </div>
        </nav>
        <img
          className="fullscreen-watermark"
          src={Logo}
          alt=""
          aria-hidden="true"
        />
      </div>
    </div>
  );
};
